import styles from './SecretIdentityModal.module.scss'
import { SecretIdentity as SecretIdentityCard } from 'components/SecretIdentity'
import { SecretIdentity } from 'types'
import { PropsWithChildren } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface LargeCardWithButtonsProps {
  secretIdentity: SecretIdentity
}

export const LargeCardWithButtons = ({ secretIdentity, children }: PropsWithChildren<LargeCardWithButtonsProps>) => {
  const { isMobile } = useResponsiveDesign()
  return (
    <SecretIdentityCard.Root secretIdentity={secretIdentity}>
      <div className={styles.identityCardContainer}>
        <div className={styles.cardContainer} data-testid="secret-identity-card">
          <SecretIdentityCard.CardFront />
        </div>
        <div className={styles.cardButtonsContainer}>
          {children}
          {!isMobile && (
            <>
              <SecretIdentityCard.DownloadButton />
              <SecretIdentityCard.ShareButton />
            </>
          )}
        </div>
      </div>
    </SecretIdentityCard.Root>
  )
}
